import { createSelector } from 'reselect';
import { State } from 'reducers';

const getContractsState =
    (state: State) =>
        state.contracts;

export const getContracts =
    createSelector(getContractsState,
        state => state.data
    );
